import React, { useState } from "react";
import querystring from "query-string";
import { getRedirectPath, deleteRedirectPath } from "../../util/Auth.js";
import { Modal, Button } from "antd";
import { exchangeCodeForAccess, saveAccessToken } from "../../util/Auth.js";
import loader from "../../components/Assets/Loading";

const Callback = props => {
  const [modalVisible, setModalVisible] = useState(false);

  const handleRedirect = async () => {
    const redirectPath = await getRedirectPath();
    deleteRedirectPath();
    if (!redirectPath) {
      props.history.push("/");
      return;
    }
    window.location.href = redirectPath;
  };

  const handleAccess = async () => {
    const parsed = querystring.parse(window.location.search.substring(1));
    if (parsed.code) {
      const access = await exchangeCodeForAccess(parsed.code);
      if (access.success) {
        saveAccessToken(access.data.access_token);
        props.fetchUser();
        handleRedirect();
      }
    } else {
      if (parsed.error === "access_denied") {
        setModalVisible(true);
      }
    }
  };

  handleAccess();

  return (
    <div>
      {loader()}
      <Modal
        title="Equipment Finder App issue"
        visible={modalVisible}
        footer={[
          <Button
            type="primary"
            onClick={e => {
              e.preventDefault();
              window.location = "/equipmentfinder/login";
            }}
          >
            Ok
          </Button>
        ]}
      >
        <div>This user is not authorized to access Equipment Finder.</div>
        <br />
        <div> Please contact IT Help Desk for assistance.</div>
      </Modal>
    </div>
  );
};

export default Callback;
